/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Runs_TitleInputs */

const vi_irrigation_runs_title = /** @type {(inputs: Irrigation_Runs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiên tưới`)
};

/**

* @param {Irrigation_Runs_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_runs_title = /** @type {((inputs?: Irrigation_Runs_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Runs_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_runs_title(inputs)
});